module.exports = __webpack_public_path__ + "images/cn-ads.b883fb622a84da41651b454344f1a099.svg";